import { render, staticRenderFns } from "./TSManifest.vue?vue&type=template&id=9910da52&scoped=true&"
import script from "./TSManifest.vue?vue&type=script&lang=js&"
export * from "./TSManifest.vue?vue&type=script&lang=js&"
import style0 from "./TSManifest.vue?vue&type=style&index=0&id=9910da52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9910da52",
  null
  
)

export default component.exports